import IcoMoon from "react-icomoon";
import iconSet from "../../assets/fonts/icomoon/selection.json";

const Icon = (props) => <IcoMoon iconSet={iconSet} {...props} />;

export default Icon;
